import { makeStyles } from 'tss-react/mui';

export const useAmendSectionStyles = makeStyles()(theme => ({
  noteSectionContent: {
    paddingTop: 0,
    paddingBottom: theme.spacing(3)
  },
  otherNoteSection: {
    paddingTop: 0,
  },
  otherDescription: {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(2)
  },
  cptCodeSelect: {
    paddingTop: theme.spacing(1)
  },
  section: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
    backgroundColor: theme.palette.grey[50]
  },
  chip: {
    backgroundColor: theme.palette.grey[300],
  }
}));
